import axios from "axios";
import { JSON_URL } from "../../config/RouterLink";
import { ERROR, openNotification } from "../../utils";

const SET_HISTORIAL_ACADEMICO = "[REQ_ACADEMICO] SET_HISTORIAL_ACADEMICO";
const DEL_REQ_ACADEMICOS = "[REQ_ACADEMICO] DEL_REQ_ACADEMICOS";
const LOADING = "[REQ_ACADEMICO] LOADING_HISTORIAL";
const LOADING_FORM = "[REQ_ACADEMICO] LOADING_FORM";
const CLEAN_STATE = "[REQ_ACADEMICO] CLEAN_STATE";
const SET_FORMULARIO = "[REQ_ACADEMICO] SET_FORMULARIO";
const IS_ACTIVE_REQ_ACADEMICO = "[REQ_ACADEMICO] IS_ACTIVE_REQ_ACADEMICOS";
const SET_FORMULARIO_CLEAN = "[REQ_ACADEMICO] SET_FORMULARIO_CLEAN";
const SET_EXISTEN_DATOS = "[REQ_ACADEMICO] SET_EXISTEN_DATOS";
const UPD_DOCUMENTO = "[REQ_ACADEMICO] UPD_DOCUMENTO";
const DEL_UPD_DOCUMENTO = "[REQ_ACADEMICO] DEL_UPD_DOCUMENTO";

//------------- STATE -------------------------
const initialState = {
  historial: [],
  existenDatos: false,
  loading: false,
  loadingForm: false,
  isReqAcademico: {},
  statusForm: {
    isSaved: false,
    isError: false,
    mensaje: null,
  },
  updateDocumento: {},
};

//------------- REDUCER -------------------------
const reqAcademicoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HISTORIAL_ACADEMICO:
      return {
        ...state,
        historial: [...action.payload],
      };

    case DEL_REQ_ACADEMICOS:
      return {
        ...state,
        historial: state.historial.filter(
          ({ idEscolaridad }) => idEscolaridad !== action.payload
        ),
      };

    case IS_ACTIVE_REQ_ACADEMICO:
      return {
        ...state,
        isReqAcademico: {
          ...action.payload,
        },
      };

    case LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case LOADING_FORM:
      return {
        ...state,
        loadingForm: action.payload,
      };
    case SET_EXISTEN_DATOS:
      return {
        ...state,
        existenDatos: action.payload,
      };

    case SET_FORMULARIO:
      return {
        ...state,
        statusForm: {
          isSaved: action.payload.isSaved,
          isError: action.payload.isError,
          mensaje: action.payload.message,
        },
      };

    case SET_FORMULARIO_CLEAN:
      return {
        ...state,
        statusForm: {
          isSaved: false,
          isError: false,
          mensaje: null,
        },
      };

    case UPD_DOCUMENTO:
      return {
        ...state,
        updateDocumento: {
          ...action.payload,
        },
      };
    case DEL_UPD_DOCUMENTO:
      return {
        ...state,
        updateDocumento: {},
      };
    case CLEAN_STATE:
      return initialState;

    default:
      return state;
  }
};

export default reqAcademicoReducer;

//------------- ACTIONS -------------------------
export const setHistorialAcademico = (state) => ({
  type: SET_HISTORIAL_ACADEMICO,
  payload: state,
});

export const removeReqAcademicoById = (id) => ({
  type: DEL_REQ_ACADEMICOS,
  payload: id,
});

export const cleanState = () => ({
  type: CLEAN_STATE,
});

export const setLoading = (status) => ({
  type: LOADING,
  payload: status,
});
const setLoadingForm = (status) => ({
  type: LOADING_FORM,
  payload: status,
});

export const setFormulario = (isError, isSaved, message) => ({
  type: SET_FORMULARIO,
  payload: {
    isError,
    message,
    isSaved,
  },
});

export const isActiveReqAcademico = (state) => ({
  type: IS_ACTIVE_REQ_ACADEMICO,
  payload: state,
});

/**
 * Función que limpia el state de los mensajes recibidos del back
 */
export const setFormularioClean = () => ({
  type: SET_FORMULARIO_CLEAN,
});

export const setExistenDatos = (state) => ({
  type: SET_EXISTEN_DATOS,
  payload: state,
});

export const setDocumentoUpd = (state) => ({
  type: UPD_DOCUMENTO,
  payload: state,
});

export const delDocumentoUpd = () => ({
  type: DEL_UPD_DOCUMENTO,
  // payload: state,
});

/**
 * Función que obtiene el historial de requisitos academicos de acuerdo al idAspirante
 * @returns El historial de Requisitos académicos del aspirante
 */
export const getHisAcademicoById = () => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const { accessToken, idAspirante } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(
        `${data.urlServer}${data.urlObtenerReqAcademicos}`,
        { idAspirante },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      )
      .then((resp) => {
        const { data } = resp;
        dispatch({ type: SET_EXISTEN_DATOS, payload: data.length > 0 });
        dispatch(setHistorialAcademico(data));
      })
      .catch((error) => {
        const { data } = error.response;
        console.error(data.mensaje);
        // openNotification("error", ERROR, data.mensaje);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  } catch (error) {
    console.error(error);
  }
};

export const saveReqAcademico = (formData) => async (dispatch, getState) => {
  dispatch(setLoadingForm(true));

  const { data } = await axios(window.location.origin + JSON_URL);
  const { accessToken } = getState().usuarioLogin;

  await axios
    .post(`${data.urlServer}${data.urlRegistroAcademico}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
        dispatch(getHisAcademicoById());
        // dispatch(setError(false));
      } else {
        dispatch(setLoadingForm(false));
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      const { data } = error.response;
      // openNotification("error", ERROR, data.mensaje);
      dispatch(setLoadingForm(false));
      dispatch(setFormulario(true, false, data.mensaje));
      // dispatch(setError(true));
    })
    .finally(() => {
      dispatch(setLoadingForm(false));
    });
};

export const updateReqAcademico = (form) => async (dispatch, getState) => {
  dispatch(setLoadingForm(true));
  //Get token
  const { accessToken } = getState().usuarioLogin;
  const { data } = await axios(window.location.origin + JSON_URL);

  await axios
    .post(`${data.urlServer}${data.urlActualizaReqAcademico}`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        dispatch(setFormulario(false, true, data.mensaje));
        dispatch(isActiveReqAcademico({}));
        dispatch(getHisAcademicoById());
      } else {
        dispatch(setFormulario(true, false, data.mensaje));
      }
    })
    .catch((error) => {
      const { data } = error.response;
      dispatch(setFormulario(true, false, data.mensaje));
    });
  dispatch(setLoadingForm(false));
};

export const removeReqAcademico = (form) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    const { accessToken } = getState().usuarioLogin;
    const { data } = await axios(window.location.origin + JSON_URL);

    await axios
      .post(`${data.urlServer}${data.urlEliminarReqAcademico}`, form, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((resp) => {
        const { data } = resp;
        if (data.idMensaje === 1) {
          dispatch(removeReqAcademicoById(form.idEscolaridad));
          openNotification("success", "Éxito", data.mensaje);
        }
      })
      .catch((error) => {
        const { data } = error.response;
        openNotification("error", ERROR, data.mensaje);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  } catch (error) {
    console.error(error);
  }
};

export const download = (rutaArchivo) => async (dispatch, getState) => {
  const { accessToken } = getState().usuarioLogin;
  try {
    const urls = await axios(window.location.origin + JSON_URL);
    return axios.post(
      `${urls.data.urlServer}${urls.data.urlDescargaAcademico}`,
      {
        rutaArchivo,
      },
      {
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: "blob",
      }
    );
  } catch (error) {
    console.log("Error en la descarga");
  }
};

export const updateArchivo = (formData) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  const { accessToken } = getState().usuarioLogin;
  const { data } = await axios(window.location.origin + JSON_URL);
  await axios
    .post(`${data.urlServer}${data.urlActualizaArchivo}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((resp) => {
      const { data } = resp;
      if (data.idMensaje === 1) {
        // dispatch(setFormulario(false, true, data.mensaje));
        openNotification("success", "Éxito", data.mensaje);
        dispatch(getHisAcademicoById());
      } else {
        openNotification("error", ERROR, data.mensaje);
      }
    })
    .catch((error) => {
      const { data } = error.response;
      openNotification("error", ERROR, data.mensaje);
    });
  dispatch(setLoading(false));
};
